import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputHtmlTextSF from '../../../widgets/form/InputHtmlTextSF'

const TermSheetScheduleRowUpdateModalUI = ({
  context, updateMode, onCancelClick, onSubmit, submitted,
  successMsg, errorList, setErrorList,
  particular, onParticularChange, particularError, setParticularError,
  termsAndConditions, onTermsAndConditionsChange, termsAndConditionsError, setTermsAndConditionsError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Edit schedule row'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF
      name='particular'
      label='Particular'
      required={true}
      value={particular}
      onChange={onParticularChange}
      error={particularError}
      setError={setParticularError}
    />
    <InputHtmlTextSF
      type='html'
      name='termsAndConditions'
      label='Terms and conditions'
      required={true}
      withToolbar={true}
      value={termsAndConditions}
      onChange={onTermsAndConditionsChange}
      error={termsAndConditionsError}
      setError={setTermsAndConditionsError}
    />
  </ModalFormUI>

export default TermSheetScheduleRowUpdateModalUI
